import { redirect, type RouteObject } from 'react-router';

import { ROUTES } from '@/config/routes';
import type { RouteHandle } from '@/hooks/useRouteHandle';

import { legacySearchTarget, migrateLegacyListParams } from './lib/finderQuery';

const page = (name: string) => () =>
  import(`./pages/${name}.tsx`).then((m) => ({ Component: m[name] }));

/**
 * 공고 찾기(specs/031) — "AI 검색"·"공고" 두 메뉴를 대체한다. 구 주소는 loader 에서 바로 새 주소로 보낸다(FR-005) —
 * 화면이 한 번 그려진 뒤 튀지 않게 렌더 전에 처리한다.
 */
export const finderRoutes: RouteObject[] = [
  {
    path: 'announcements',
    loader: ({ request }) => {
      const migrated = migrateLegacyListParams(new URL(request.url).searchParams);
      if (!migrated) return null;
      const query = migrated.toString();
      return redirect(`${ROUTES.workspace.announcements}${query ? `?${query}` : ''}`);
    },
    lazy: page('FinderPage'),
    handle: { title: '공고 찾기', feature: 'ANNOUNCEMENT_FINDER' } satisfies RouteHandle,
  },
  {
    path: 'search',
    loader: ({ request }) => redirect(legacySearchTarget(new URL(request.url).searchParams)),
    // loader 가 항상 redirect 하므로 그려지지 않는다 — 빈 leaf 경고 방지용
    Component: () => null,
    handle: { feature: 'ANNOUNCEMENT_FINDER' } satisfies RouteHandle,
  },
];
